import { FontSettings } from 'components/fontSettings/fontSettings.module';
import { ChatSettingsHeader } from 'components/header/types/chatSettingsHeader/chatSettingsHeader.module';
import { LanguagePreference } from 'components/languagePreference/languagePreference.module';
import { BOT_MODE, CHAT_SETTINGS } from 'consts/enum';
import { addClass, focusElement, removeClass, setCustomTagHTML } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import { chatSettingsOption } from './chatSettings.model';
import { ChatSettingsTemplate } from './chatSettings.template';

const { FONT_SIZE, LANGUAGE_PREFERENCE } = CHAT_SETTINGS;
export class ChatSettings {
	constructor() {
		this.init();
	}

	init() {
		this.initData();
		this.initWrapper();
		this.initComponents();
		this.initEvents();
	}

	initData() {
		this.data = { ...chatSettingsOption };

		const chatSettingsOptions = [
			{
				id: FONT_SIZE,
				title: ENGT_CHAT.get('GENERIC_STRINGS')?.['FONT_SIZE'] || 'Font Size',
			},
		];

		if (ENGT_CHAT.get('config.isMultilingualEnabled')) {
			chatSettingsOptions.push({
				id: LANGUAGE_PREFERENCE,
				title: ENGT_CHAT.get('GENERIC_STRINGS')?.['LANGUAGE_PREFERENCE'] || 'Language Preference',
			});
		}

		this.setter({
			currentOpen: null,
			optionsData: chatSettingsOptions,
			themeColor: ENGT_CHAT.get('config.themeColor'),
		});
	}

	initWrapper() {
		const wrapper = document.createElement('div');
		wrapper.classList.add('engt-settings');
		wrapper.id = 'engtChatSettings';
		wrapper.setAttribute('tabindex', '-1');
		wrapper.innerHTML = ChatSettingsTemplate(this.data);

		this.html = wrapper;
	}

	initComponents() {
		const header = new ChatSettingsHeader().render();

		setCustomTagHTML(this.html.querySelector('header'), header);
	}

	initEvents() {
		const ref = this;
		const options = this.html.querySelector('ul').children;

		for (let i = 0; i < options.length; i++) {
			options[i].querySelector('.engt-menu-option-name').addEventListener('click', function () {
				ref.onChatOptionClick.call(ref, this.parentNode.id);
			});
		}
		if (options.length === 1) ref.onChatOptionClick.call(ref, FONT_SIZE);

		ENGT_CHAT.set('showChatSettingsScreen', this.showChatSettingsScreen.bind(this));
		ENGT_CHAT.set('hideChatSettingsScreen', this.hideChatSettingsScreen.bind(this));
		ENGT_CHAT.set('reRenderChatSettings', this.reRenderChatSettings.bind(this));
	}

	onChatOptionClick(chatOptionId) {
		const { currentOpen } = this.data;
		const optionsWrapper = this.html.querySelector('ul')?.children;

		function getSettingsInstance(id) {
			if (id === FONT_SIZE) return new FontSettings().render();
			if (id === LANGUAGE_PREFERENCE) return new LanguagePreference().render();
		}

		if (chatOptionId === currentOpen) {
			this.html.querySelector(`#${chatOptionId}`).setAttribute('data-active-click', 'false');
			this.html.querySelector(`#${chatOptionId}Tab`).innerHTML = '';
			this.setter({
				currentOpen: null,
			});
		} else {
			for (let i = 0; i < optionsWrapper?.length; i++) {
				const currentElement = optionsWrapper[i];
				const isActive = currentElement.id === chatOptionId;
				const currentTabInstance = this.html.querySelector(`#${currentElement.id}Tab`);

				if (currentTabInstance) {
					if (isActive) {
						currentTabInstance.appendChild(getSettingsInstance(currentElement.id));
					} else {
						currentTabInstance.innerHTML = '';
					}
				}

				currentElement.setAttribute('data-active-click', isActive);
			}

			this.setter({
				currentOpen: chatOptionId,
			});
		}
	}

	showChatSettingsScreen() {
		this.reRenderChatSettings();
	}

	hideChatSettingsScreen() {
		addClass(this.html, 'engt-chat-settings-hidden');
		document.querySelector('.engt-pages').style.display = null;
		setTimeout(
			() => {
				removeClass(this.html, 'engt-chat-settings-visible');
				ENGT_CHAT.get('reRenderChatScreen')();
				document.getElementById('engtChatSettings').setAttribute('tabindex', -1);
			},
			ENGT_CHAT.get('config.bot_mode') === BOT_MODE.STANDALONE ? 0 : 600
		);
	}

	reRenderChatSettings() {
		const wrapper = document.getElementById('engtChatSettings');
		this.init();
		removeClass(this.html, 'engt-chat-settings-hidden');
		addClass(this.html, 'engt-chat-settings-visible');
		ENGT_CHAT.get('reRenderChatScreen')();
		document.querySelector('.engt-pages').style.display = 'none';
		wrapper.parentNode.replaceChild(this.html, wrapper);
		focusElement(this.html.querySelector('#chatSettingOptions > #FONT_SIZE'));
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
